import React from 'react'
import IdPhotoContent from '../../../../components/SignUp/IdsScreens/IdPhotoContent/IdPhotoContent'

const IdSignUpBackScreen = () => {
    return (
        <IdPhotoContent type="Back_id" />
    )
}

export default IdSignUpBackScreen